<section class="not-allowed">
  <h1 class="txt txt-web-h2 u-mb20">Ruta no encontrada</h1>
  <h3 class="txt txt--grey txt-web-body-large u-mb50">
    ¡Oops! La pagina a la que ingreso no existe. Por favor regresa a la pagina principal o login.
  </h3>

  <img src="../../../../assets/images/admin-login.svg" alt="Error"/>

  <button class="vs-btn-blue" (click)="goBack()">
    Regresar
  </button>
</section>
